var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentStatHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1120_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0611 35.488C21.0718 36.2096 22.4282 36.2096 23.4389 35.488C28.4905 31.8818 33.3281 27.733 36.6744 22.4238C38.3509 19.764 39.0537 17.6129 39.3301 15.854C39.4416 15.2347 39.5 14.5958 39.5 13.9426C39.5 8.26922 35.097 3.67004 29.6655 3.67004C26.4197 3.67004 23.5411 5.31258 21.75 7.84533C19.9589 5.31258 17.0803 3.67004 13.8345 3.67004C8.40304 3.67004 4 8.26922 4 13.9426C4 14.5958 4.05836 15.2347 4.16994 15.854C4.44634 17.6129 5.14906 19.764 6.82555 22.4238C10.1719 27.733 15.0095 31.8818 20.0611 35.488Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0611 31.17C21.0718 31.8916 22.4282 31.8916 23.4389 31.17C29 28.17 31 27.17 36.6744 22.4238C38.3509 19.764 39.0537 17.6129 39.3301 15.854C39.4416 15.2347 39.5 14.5958 39.5 13.9426C39.5 8.26922 35.097 3.67004 29.6655 3.67004C26.4197 3.67004 23.5411 5.31258 21.75 7.84533C19.9589 5.31258 17.0803 3.67004 13.8345 3.67004C8.40304 3.67004 4 8.26922 4 13.9426C4 14.5958 4.05836 15.2347 4.16994 15.854C4.44634 17.6129 5.14906 19.764 6.82555 22.4238C13 27.17 15 28.17 20.0611 31.17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1120_15",
    x: 0,
    y: 0.0000439584,
    width: 43.5,
    height: 40.3591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1120_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1120_15",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentStatHeart);
export default __webpack_public_path__ + "static/media/content-stat-heart.21e2e88e775e0a912aeb5d4d7785c1dc.svg";
export { ForwardRef as ReactComponent };